import { render, staticRenderFns } from "./ControlLayout.vue?vue&type=template&id=264ddcaa&scoped=true"
import script from "./ControlLayout.vue?vue&type=script&lang=js"
export * from "./ControlLayout.vue?vue&type=script&lang=js"
import style0 from "./ControlLayout.vue?vue&type=style&index=0&id=264ddcaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ddcaa",
  null
  
)

export default component.exports